import userStore from "./User";
import chatStore from "./UserChat";
import videoRoomStore from "./VideoRoom"
import adminStore from "./Admin/Users"
import usersStore from "./Users"
import friendsStore from "./Friends"


const rootStore = {
    userStore,
    usersStore,
    friendsStore,
    chatStore,
    videoRoomStore,
    adminStore
}

export default rootStore